import React,{ReactNode,useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next'
import Graph from './Graph'
// import CanvasJSReact from './../canvasjs.stock.react';
import Chart from "react-google-charts";
import {
  Box,
  Container,
  Stack,
  SimpleGrid,
  Text,
  Link,
  VisuallyHidden,
  chakra,
  Image,
  Icon,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  
} from '@chakra-ui/react';
import {
  ChevronDownIcon,
  EmailIcon,
  PhoneIcon,
  AddIcon,
  MinusIcon,
  CheckIcon,
} from '@chakra-ui/icons';
import { Twitter,Linkedin,Facebook,Youtube} from 'react-bootstrap-icons';
import './../style.css';
import eventBus from "../eventBus";


// var CanvasJS = CanvasJSReact.CanvasJS;
// var CanvasJSStockChart = CanvasJSReact.CanvasJSStockChart;

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2} fontFamily={'poppins'} color={useColorModeValue('#fff', '#000')}>
      {children}
    </Text>
  );
};

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function LargeWithAppLinksAndSocial() {
  const { t } = useTranslation()
  const [theme, setTheme] = useState('');
  const [currentFaq, setCurrentFaq] = useState('');
  const OverlayTwo = () => (
    <ModalOverlay
      bg='#101b26bd'
      backdropFilter= 'opacity(20%)'
      backdropInvert='10%'
      backdropBlur='2px'
    />
  )
  const [overlay, setOverlay] = React.useState(<OverlayTwo />)
  const [toggler, setToggler] = useState(false);
  const { 
    isOpen: isOpenPrivacyModal, 
    onOpen: onOpenPrivacyModal, 
    onClose: onClosePrivacyModal,
  } = useDisclosure()
  const {
    isOpen:  isOpenTermsModal, 
    onOpen: onOpenTermsModal, 
    onClose: onCloseTermsModal   
  } = useDisclosure();
  const {
    isOpen:  isOpenAboutModal, 
    onOpen: onOpenAboutModal, 
    onClose: onCloseAboutModal   
  } = useDisclosure();
  const {
    isOpen:  isOpenTokenModal, 
    onOpen: onOpenTokenModal, 
    onClose: onCloseTokenModal   
  } = useDisclosure();
  const {
    isOpen:  isOpenFaqModal, 
    onOpen: onOpenFaqModal, 
    onClose: onCloseFaqModal   
  } = useDisclosure();
  const {
    isOpen:  isOpenContactModal, 
    onOpen: onOpenContactModal, 
    onClose: onCloseContactModal   
  } = useDisclosure();

  const [widthh, setWidth] = useState(window.innerWidth);


  
  // const containerProps = {
  //   width: "800px",
  //   height: "400px",
  //   margin: "auto"
  // };  

  useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth));
  },[])
  useEffect(() => {
    if(localStorage.getItem('theme')==='dark'){
      setTheme('light');
    }else if(localStorage.getItem('theme')==='light'){
      setTheme('dark');
    }
    eventBus.on("changeTheme", (data: any) =>{
      if(data.message==='dark'){
        setTheme('light');
      }else if(data.message==='light'){
        setTheme('dark');
      }
    });
  },[theme]);
  return (
    <>
    {/* <div className="graph_container">
      <Graph/>
    </div> */}
    <Box
    backgroundImage={'images/footer.png'}
    backgroundRepeat={'no-repeat'}
    backgroundPosition={'center bottom'}
    backgroundSize={'30%'}

    backgroundColor={useColorModeValue('#001324', '#f1f1f1')}
    
      color={useColorModeValue('gray.700', 'gray.200')}>
      <Container as={Stack} maxW={'7xl'} py={10}>
      {/* <Text
            
              paddingBottom={10}
              fontFamily={'heading'}
              fontWeight={600}
              color={useColorModeValue('white', '#000')}>
              PRIM
              
              <Text as={'span'} color={'#0088fe'}>
              SWAP
              </Text>
              
            </Text> */}

<Image

                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
              height={'22px'}
              width={'121px'}
              marginTop={'4px'}
                src={
                  theme==='dark' ? 'images/logo.png' : 'images/light_logo.png'
                }
              />
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8} paddingTop={'40px'}>
          {/* <Stack align={'flex-start'}> */}
            {/* <ListHeader>PrimSwap</ListHeader> */}
            {/* <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'}>{t('about')}</Link>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'}>{t('prim')}</Link>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'}>{t('faq')}</Link> */}
           
          {/* </Stack> */}

          <Stack align={'flex-start'}>
            <ListHeader>{t('prim_swap')}</ListHeader>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenAboutModal()
              }}>{t('about')}</Link>
            <Link  fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} 
              onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenTokenModal()
              }}>{t('token')}
            </Link>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenFaqModal()
              }}>{t('faq')}</Link>
          </Stack>

          <Stack align={'flex-start'} >
            <ListHeader>{t('resources')}</ListHeader>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenPrivacyModal()
              }}>{t('privacy')}</Link>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenTermsModal()
              }}>{t('terms')}</Link>
            <Link fontFamily={'poppins'} color={useColorModeValue('gray.300', '#333')} href={'#'} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpenContactModal()
              }}>{t('contact')}</Link>
          </Stack>

          <Stack align={'flex-start'}>
            {/* <AppStoreBadge />
            <PlayStoreBadge /> */}
            <Stack direction={'row'} spacing={3} className="social_images">
              <span className="social_icons" onClick={()=>window.open('https://twitter.com/PrimPlatform')}><Twitter size={24} color="#ffffff" /></span>
              <span className="social_icons" onClick={()=>window.open('https://www.linkedin.com/company/prim-technologies/about/?viewAsMember=true')}><Linkedin size={24} color="#ffffff" /></span>
              <span className="social_icons" onClick={()=>window.open('https://www.facebook.com/primplatform/')}><Facebook size={24} color="#ffffff" /></span>
              <span className="social_icons" onClick={()=>window.open('https://www.youtube.com/channel/UCzaG8DHsvDZ-11D6gnTPJGQ')}><Youtube size={24} color="#ffffff" /></span>
            {/* <Image
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
             width={'36px'}
             height={'36px'}

                src={
                  'images/facebook.png'
                }
                onClick={()=>window.open('https://www.facebook.com/primplatform/')}
              />
              <Image
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
                
                width={'52px'}
                height={'37px'}
                src={
                  'images/twitter.png'
                }
                onClick={()=>window.open('https://twitter.com/PrimPlatform')}
              /> */}
              </Stack>
              
       {/* <Stack direction={'row'} spacing={3} className="social_images">      
          <Image 
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
             
                width={'45px'}
                height={'52px'}
                src={
                  'images/youtube.png'
                }
                onClick={()=>window.open('https://www.youtube.com/channel/UC1AUAzfH6M4NFfggwB2KWMA')}
              />
          <Image
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
                width={'40px'}
                height={'46px'}
                src={
                  'images/linkedin.png'
                }
                onClick={()=>window.open('https://www.linkedin.com/company/prim-technologies/about/?viewAsMember=true')}
              />
       </Stack> */}
             
          </Stack>
        </SimpleGrid>
      </Container>

      <Box
        // borderTopWidth={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.700')}>
        {/* <Container
          as={Stack}
          maxW={'6xl'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ md: 'space-between' }}
          align={{ md: 'center' }}>
          <Text>© 2022 Chakra Templates. All rights reserved</Text>
          <Stack direction={'row'} spacing={6}>
            <SocialButton label={'Twitter'} href={'#'}>
              <FaTwitter />
            </SocialButton>
            <SocialButton label={'YouTube'} href={'#'}>
              <FaYoutube />
            </SocialButton>
            <SocialButton label={'Instagram'} href={'#'}>
              <FaInstagram />
            </SocialButton>
          </Stack>
        </Container> */}
      </Box>

      <Modal  isCentered isOpen={isOpenPrivacyModal} onClose={onClosePrivacyModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
                boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
        textAlign={'center'}
        width="350px"
        className={theme==='light' ? "light_privacy_policy privacy_policy" : "dark_privacy_policy privacy_policy"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='50px'
            textAlign={'left'}
            paddingTop="20px"
          
            >{t('privacy')}</ModalHeader>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody >
              <React.Fragment>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_1_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_1_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_2_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_2_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_3_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_3_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_4_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_4_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_5_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_5_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_6_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_6_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_7_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_7_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_8_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_8_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_9_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_9_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_10_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_10_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_11_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_11_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_12_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_12_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_13_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_13_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_14_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_14_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_15_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_15_content') }}></p>
                  <h2 dangerouslySetInnerHTML={{ __html: t('privacy_16_head') }}></h2>
                  <p dangerouslySetInnerHTML={{ __html: t('privacy_16_content') }}></p>
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal  isCentered isOpen={isOpenTermsModal} onClose={onCloseTermsModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
                boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
        textAlign={'center'}
        width="350px"
        className={theme==='light' ? "light_privacy_policy privacy_policy" : "dark_privacy_policy privacy_policy"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='50px'
            textAlign={'left'}
            paddingTop="20px"
          
            >{t('terms')}</ModalHeader>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody >
              <React.Fragment>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_1_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_1_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_2_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_2_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_3_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_3_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_4_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_4_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_5_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_5_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_6_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_6_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_7_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_7_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_8_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_8_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_9_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_9_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_10_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_10_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_11_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_11_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_12_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_12_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_13_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_13_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_14_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_14_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_15_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_15_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_16_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_16_content') }}></p>
                <h2 dangerouslySetInnerHTML={{ __html: t('terms_17_head') }}></h2>
                <p dangerouslySetInnerHTML={{ __html: t('terms_17_content') }}></p>
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal  isCentered isOpen={isOpenAboutModal} onClose={onCloseAboutModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
                boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
        textAlign={'center'}
        width="350px"
        className={theme==='light' ? "light_privacy_policy privacy_policy" : "dark_privacy_policy privacy_policy"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='50px'
            textAlign={'left'}
            paddingTop="20px"
          
            >{t('about-us')}</ModalHeader>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody >
              <React.Fragment>
                  <p>{t('about1')}</p>
                  <p>{t('about2')}</p>
                  <p>{t('about3')}</p>
                  <p>{t('about4')}</p>
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>


      <Modal  isCentered isOpen={isOpenTokenModal} onClose={onCloseTokenModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
                boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
        textAlign={'center'}
        width="350px"
        className={theme==='light' ? "light_privacy_policy privacy_policy" : "dark_privacy_policy privacy_policy"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='0px'
            textAlign={'left'}
            paddingTop="20px"
          
            >{t('token')}</ModalHeader><br></br>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody paddingTop='0px'>
              <React.Fragment>
              {/* <Chart
                width={widthh <= 600 ? "auto" : "100%"}
                // width={"auto"}
                // height={"auto"}
                height={widthh <= 600 ? "auto" : "360px"}
                chartType="PieChart"
                // loader={<div>Loading Pie Chart</div>}
                data={[
                  ["Task", "Hours per Day"],
                  ["Administration and expenses of program", 400000000],
                  ["Redistributed to all holders, proportionately",1000000000],
                  ["Liquidity pool", 1000000000],
                  ["Others", 17600000000],
                ]}
                options={{
                  // title: 'Tokenization',
                  is3D: false,
                  pieHole: 0.4,
                  legend: {
                    textStyle: {
                      color: theme==='light' ? "black": "white",
                      // fontSize: 20,
                      fontSize: widthh <= 600 ? "auto" : 15,
                    },
                    alignment: "center",
                  },
                  backgroundColor: "transparent",
                  colors: [
                    "#6AB187",
                    "#B3C100",
                    "#EA6447",
                    "#4CB5F5",
                  ],
                }}
              /> */}
                  <a href="#img1">
                    <img src="../images/tokenomics_final.png" style={{width:"38%",objectFit:"contain",display:"inherit"}} className="tokenomics_img"></img>
                    
                  </a>

                  <a href="#" className="lightbox" id="img1">
                    <span style={{backgroundImage: "url('../images/tokenomics_final.png')"}}></span>
                  </a>

                  {/* <Box className="row token_data">
                      <Box className="col-xl-6">
                          <h3>{t('token_head1')}</h3>
                          <ul>
                            <li>
                              <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data1')}
                            </li>
                          </ul>
                      </Box>
                      <Box className="col-xl-6">
                        <h3>{t('token_head2')}</h3>
                        <ul>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data2_1')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data2_2')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data2_3')}
                          </li>
                        </ul>
                      </Box>
                      <Box className="col-xl-6">
                        <h3>{t('token_head3')}</h3>
                        <ul>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data3_1')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data3_2')}

                          </li>
                        </ul>
                      </Box>
                      <Box className="col-xl-6">
                        <h3>{t('token_head4')}</h3>
                        <ul>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data4_1')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data4_2')}
                          </li>
                        </ul>
                      </Box>
                      <Box className="col-xl-6">
                        <h3>{t('token_head5')}</h3>
                        <ul>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data5_1')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data5_2')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data5_3')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data5_4')}
                          </li>
                        </ul>
                      </Box>
                      <Box className="col-xl-6">
                        <h3>{t('token_head6')}</h3>
                        <ul>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data6_1')}
                          </li>
                          <li>
                            <span><Icon as={CheckIcon} w={4} h={4}/></span> {t('token_data6_2')}
                          </li>
                        </ul>
                      </Box>
                  </Box> */}
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>


      <Modal  isCentered isOpen={isOpenFaqModal} onClose={onCloseFaqModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
                boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
        textAlign={'center'}
        width="350px"
        className={theme==='light' ? "light_privacy_policy privacy_policy" : "dark_privacy_policy privacy_policy"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='50px'
            textAlign={'left'}
            paddingTop="20px"
          
            >{t('faq')}</ModalHeader>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody className={theme==='dark' ? "dark_faq" : "light_faq"}>
              <React.Fragment>
                <div
                  className="accordion"
                  id="accordionEx parent"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <a href="#" id="General"></a>
                  <div className="accordion-header" role="tab" id={"headingOne0"}>
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href={"#collapseOne0"}
                      aria-expanded="false"
                      aria-controls={"collapseOne0"}
                      className={currentFaq==='0' ? 'accordion-button' : 'accordion-button collapsed'}
                      onClick={()=>setCurrentFaq('0')}
                    >
                      {t('faq_ques1')}
                      <span>
                        {(currentFaq!=='' && currentFaq==='0') ?
                        (<Icon
                        as={MinusIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='0' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />):(<Icon
                        as={AddIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='0' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />)}
                      </span>
                    </a>
                    
                    <div
                      id={"collapseOne0"}
                      className={currentFaq==='0' ? 'collapse show' : 'collapse'} 
                      role="tabpanel"
                      aria-labelledby={"headingOne0"}
                      data-parent="#accordionEx"
                    >
                      <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans1') }}>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="accordion"
                  id="accordionEx parent"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <a href="#" id="General"></a>
                  <div className="accordion-header" role="tab" id={"headingOne1"}>
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href={"#collapseOne1"}
                      aria-expanded="false"
                      aria-controls={"collapseOne1"}
                      className={currentFaq==='1' ? 'accordion-button' : 'accordion-button collapsed'}
                      onClick={()=>setCurrentFaq('1')}
                    >
                      {t('faq_ques2')}
                      <span>
                        {(currentFaq!=='' && currentFaq==='1') ?
                        (<Icon
                        as={MinusIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='1' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />):(<Icon
                        as={AddIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='1' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />)}
                      </span>
                    </a>
                    
                    <div
                      id={"collapseOne1"}
                      className={currentFaq==='1' ? 'collapse show' : 'collapse'} 
                      role="tabpanel"
                      aria-labelledby={"headingOne1"}
                      data-parent="#accordionEx"
                    >
                      <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans2') }}>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="accordion"
                  id="accordionEx parent"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <a href="#" id="General"></a>
                  <div className="accordion-header" role="tab" id={"headingOne2"}>
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href={"#collapseOne2"}
                      aria-expanded="false"
                      aria-controls={"collapseOne2"}
                      className={currentFaq==='2' ? 'accordion-button' : 'accordion-button collapsed'}
                      onClick={()=>setCurrentFaq('2')}
                    >
                      {t('faq_ques3')}
                      <span>
                        {(currentFaq!=='' && currentFaq==='2') ?
                        (<Icon
                        as={MinusIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='2' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />):(<Icon
                        as={AddIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='2' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />)}
                      </span>
                    </a>
                    
                    <div
                      id={"collapseOne2"}
                      className={currentFaq==='2' ? 'collapse show' : 'collapse'} 
                      role="tabpanel"
                      aria-labelledby={"headingOne2"}
                      data-parent="#accordionEx"
                    >
                      <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans3') }}>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                    className="accordion"
                    id="accordionEx parent"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <a href="#" id="General"></a>
                    <div className="accordion-header" role="tab" id={"headingOne14"}>
                      <a
                        data-toggle="collapse"
                        data-parent="#accordionEx"
                        href={"#collapseOne14"}
                        aria-expanded="false"
                        aria-controls={"collapseOne14"}
                        className={currentFaq==='14' ? 'accordion-button' : 'accordion-button collapsed'}
                        onClick={()=>setCurrentFaq('14')}
                      >
                        {t('faq_ques7')}
                        <span>
                          {(currentFaq!=='' && currentFaq==='14') ?
                          (<Icon
                          as={MinusIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='14' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />):(<Icon
                          as={AddIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='14' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />)}
                        </span>
                      </a>
                      
                      <div
                        id={"collapseOne14"}
                        className={currentFaq==='14' ? 'collapse show' : 'collapse'} 
                        role="tabpanel"
                        aria-labelledby={"headingOne14"}
                        data-parent="#accordionEx"
                      >
                        <div className="accordion-desc faq_div7" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans7') }}>
                            
                        </div>
                      </div>
                    </div>
                  </div>

                <div
                  className="accordion"
                  id="accordionEx parent"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <a href="#" id="General"></a>
                  <div className="accordion-header" role="tab" id={"headingOne3"}>
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href={"#collapseOne3"}
                      aria-expanded="false"
                      aria-controls={"collapseOne3"}
                      className={currentFaq==='3' ? 'accordion-button' : 'accordion-button collapsed'}
                      onClick={()=>setCurrentFaq('3')}
                    >
                      {t('faq_ques4')}
                      <span>
                        {(currentFaq!=='' && currentFaq==='3') ?
                        (<Icon
                        as={MinusIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='3' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />):(<Icon
                        as={AddIcon}
                        transition={'all .25s ease-in-out'}
                        transform={currentFaq==='3' ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                      />)}
                      </span>
                    </a>
                    
                    <div
                      id={"collapseOne3"}
                      className={currentFaq==='3' ? 'collapse show' : 'collapse'} 
                      role="tabpanel"
                      aria-labelledby={"headingOne3"}
                      data-parent="#accordionEx"
                    >
                      <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans4') }}>
                      </div>
                    </div>
                  </div>
                </div>


                  <div
                    className="accordion"
                    id="accordionEx parent"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <a href="#" id="General"></a>
                    <div className="accordion-header" role="tab" id={"headingOne6"}>
                      <a
                        data-toggle="collapse"
                        data-parent="#accordionEx"
                        href={"#collapseOne6"}
                        aria-expanded="false"
                        aria-controls={"collapseOne6"}
                        className={currentFaq==='6' ? 'accordion-button' : 'accordion-button collapsed'}
                        onClick={()=>setCurrentFaq('6')}
                      >
                        {t('faq_ques5')}
                        <span>
                          {(currentFaq!=='' && currentFaq==='6') ?
                          (<Icon
                          as={MinusIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='6' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />):(<Icon
                          as={AddIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='6' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />)}
                        </span>
                      </a>
                      
                      <div
                        id={"collapseOne6"}
                        className={currentFaq==='6' ? 'collapse show' : 'collapse'} 
                        role="tabpanel"
                        aria-labelledby={"headingOne6"}
                        data-parent="#accordionEx"
                      >
                        <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans5') }}>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="accordion"
                    id="accordionEx parent"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <a href="#" id="General"></a>
                    <div className="accordion-header" role="tab" id={"headingOne7"}>
                      <a
                        data-toggle="collapse"
                        data-parent="#accordionEx"
                        href={"#collapseOne7"}
                        aria-expanded="false"
                        aria-controls={"collapseOne7"}
                        className={currentFaq==='7' ? 'accordion-button' : 'accordion-button collapsed'}
                        onClick={()=>setCurrentFaq('7')}
                      >
                        {t('faq_ques6')}
                        <span>
                          {(currentFaq!=='' && currentFaq==='7') ?
                          (<Icon
                          as={MinusIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='7' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />):(<Icon
                          as={AddIcon}
                          transition={'all .25s ease-in-out'}
                          transform={currentFaq==='7' ? 'rotate(180deg)' : ''}
                          w={6}
                          h={6}
                        />)}
                        </span>
                      </a>
                      
                      <div
                        id={"collapseOne7"}
                        className={currentFaq==='7' ? 'collapse show' : 'collapse'} 
                        role="tabpanel"
                        aria-labelledby={"headingOne4"}
                        data-parent="#accordionEx"
                      >
                        <div className="accordion-desc" style={{color:"white",marginBottom:"20px",fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: t('faq_ans6') }}>
                            
                        </div>
                      </div>
                    </div>
                  </div>
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal  isCentered isOpen={isOpenContactModal} onClose={onCloseContactModal}>
        {overlay}
          <ModalContent
          borderColor={"#0088fe"}
          borderWidth="1px"
          transition="all 0.2s ease-in-out"
          boxShadow="-1px 0px 6px #0088fe;"
          borderRadius="14px"
          textAlign={'center'}
          width="350px"
          className={theme==='light' ? "light_contact_us contact_modal" : "dark_contact_us contact_modal"}
          bg={useColorModeValue('#000c16', 'gray.800')}>
            <ModalHeader
            color={'#fff'} 
            paddingBottom='50px'
            textAlign={'left'}
            paddingTop="20px"
            className="contact_heading"
            >{t('contact_title')}</ModalHeader>
            <ModalCloseButton 
            marginTop="10px"
            borderColor={'none'}
            color={"#fff"}
            fontWeight={800}
            fontSize='16px'
            />
            <ModalBody >
              <React.Fragment>
                  <Box className='row'>
                    <Box className="col-xl-3">
                    <Image alt={'Hero Image'}
                      src={"images/location.png"}></Image>
                    </Box>
                    <Box className="col-xl-9">
                      <p>{t('contact1')}</p>
                      <p>{t('contact2')}</p>
                      <p>{t('contact3')}</p>
                    </Box>
                  </Box>
                  <Box className='row' style={{marginTop:"20px"}}>
                    <Box className="col-xl-3">
                    <Image alt={'Hero Image'}
                      src={"images/phone.png"}></Image>
                    </Box>
                    <Box className="col-xl-9" style={{margin:"auto"}}>
                      <p>{t('contact4')}</p>
                    </Box>
                  </Box>
                  <Box className='row' style={{marginTop:"24px"}}>
                    <Box className="col-xl-3">
                    <Image alt={'Hero Image'}
                      src={"images/email.png"}></Image>
                    </Box>
                    <Box className="col-xl-9" style={{margin:"auto"}}>
                      <p>{t('contact5')}</p>
                    </Box>
                  </Box>
              </React.Fragment>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>


    </Box>
    </>
  );
}